import { inject, Injectable } from '@angular/core';
import { PlanPaymentIds } from '@interfaces';
import { DocumentReference } from 'firebase/firestore';
import {
    DbCollection,
    DbDocsService,
    PlanPaymentPeriod,
    PlanType,
    RemoteConfigService,
    UserState
} from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class CheckoutSessionsRepository {
    private readonly dbService = inject(DbDocsService);
    private readonly remoteConfigService = inject(RemoteConfigService);
    private readonly userState = inject(UserState);
    private readonly priceIds: PlanPaymentIds;

    constructor() {
        const priceIdsAsString = this.remoteConfigService.getItem('priceIds').asString();
        this.priceIds = JSON.parse(priceIdsAsString);
    }

    public create(
        planType: PlanType,
        period: PlanPaymentPeriod
    ): Promise<DocumentReference | null> {
        return this.dbService.add(this.getCollectionPath(), {
            price: this.priceIds[planType][period],
            success_url: window.location.origin,
            cancel_url: window.location.origin
        });
    }

    private getCollectionPath(): string {
        return `${DbCollection.Root.Users}/${this.userState.id()!}/${DbCollection.Users.CheckoutSessions}`;
    }
}
